<template>
    <div class="wrap td-fcc td-fc">
        <div class="logo-box">
            <img class="logo" :src="GLOBAL.Images.logo" alt="">
        </div>
        <div class="login-box">
            <div class="login-title td-fcc">
                <div class="cycle-box td-fcc">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <span class="title">登录</span>
            </div>
            <div class="input-box">
                <el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="login-form">
                    <template v-for="(item, index) in formField">
                        <div class="verify-box"
                             v-if="item.field == 'code'"
                             :key="index"
                        >
                            <el-form-item :prop="item.field" :label="item.label">
                                <el-input
                                        v-model="loginForm[item.field]"
                                        :placeholder="item.desc"
                                        :prefix-icon="item.icon"
                                        :type="item.form_type"
                                ></el-input>
                            </el-form-item>
                            <div
                                    class="verify-code"
                                    @click="refreshCode"
                            >
                                <s-identify :identifyCode="identifyCode"></s-identify>
                            </div>
                        </div>
                        <el-form-item
                                v-else
                                :key="index"
                                :prop="item.field"
                                :label="item.label"
                        >
                            <el-input
                                    v-model="loginForm[item.field]"
                                    :placeholder="item.desc"
                                    :prefix-icon="item.icon"
                                    :type="item.form_type"
                            ></el-input>
                        </el-form-item>
                    </template>

                    <el-form-item>
                        <div class="button-box">
                            <el-button
                                    class="submit-btn"
                                    type="success"
                                    @click="submitForm('loginForm')"
                            >登录
                            </el-button>
                            <el-button
                                    class="inquiry-btn"
                                    type="danger"
                                    @click="resetForm('loginForm')"
                            >重置
                            </el-button>
                        </div>
                    </el-form-item>
                    <div class="tips td-fbc">
                        <span class="to-register" @click="$router.push('/register')">去注册</span>
                        <span @click="$router.replace('/home')">返回首页</span>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="login-bottom-img td-fes">
            <img src="@/assets/img/login_bg_2.png" alt="">
        </div>
    </div>
</template>

<script>
    import Lockr from "lockr";
    import SIdentify from "@/components/Identify";
    import {login} from "@/api/login";

    export default {
        name: "index",
        components: {
            SIdentify
        },
        data() {
            // 验证码验证规则
            var validateCode = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("请输入验证码"));
                } else {
                    if (value !== this.identifyCode) {
                        callback(new Error("验证码错误"));
                    }
                    callback();
                }
            };
            return {
                identifyCode: '',
                loginForm: {
                    emp_no: "",
                    password: "",
                    code: ""
                },
                formField: [{
                    label: "账 号",
                    field: "emp_no",
                    form_type: "text",
                    icon: "el-icon-user",
                    desc: "请输入登录账号"
                },
                    {
                        label: "密 码",
                        field: "password",
                        form_type: "password",
                        icon: "el-icon-lock",
                        desc: "请输入登录密码"
                    },
                    {
                        label: "验证码",
                        field: "code",
                        form_type: "text",
                        icon: "el-icon-mobile",
                        desc: "请输入验证码"
                    }
                ],
                loginRules: {
                    emp_no: [{
                        required: true,
                        message: "请输入登录账号",
                        trigger: "blur"
                    }],
                    password: [{
                        required: true,
                        message: "请输入登录密码",
                        trigger: "blur"
                    }],
                    code: [{validator: validateCode, trigger: "blur"}]
                },
                isLoading: false
            };
        },
        methods: {
            // 更新验证码
            refreshCode() {
                this.identifyCode = Math.random()
                    .toString(36)
                    .substr(2)
                    .slice(1, 5);
                // this.loginForm.code = this.identifyCode
            },
            // 表单重置
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            // 表单提交
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.requestForm()
                    }
                });
            },
            requestForm() {
                if (this.isLoading) return
                this.isLoading = true
                let {code, ...params} = this.loginForm
                let redirect = this.$route.query.redirect
                this.$store
                    .dispatch("Login", params)
                    .then(res => {
                        console.log('redirect=====>', redirect)
                        this.$router.replace({
                            path: redirect || '/word'
                        });
                        this.isLoading = false
                    })
                    .catch((err) => {
                        this.refreshCode()
                        this.isLoading = false
                    })
            }
        },
        mounted () {
            let that = this;
            document.onkeydown = function (e) {
                //事件对象兼容
                let e1 = e || event || window.event || arguments.callee.caller.arguments[0];
                if (e1 && e1.keyCode == 13) {
                    console.log("Enter");
                    that.submitForm('loginForm');
                }
            };
        },
        created() {
            this.refreshCode()
        }
    };
</script>

<style lang="less" scoped>
    @import "../../assets/css/form";

    .wrap {
        background: #dcebff;
        background: url("../../assets/img/maoboli.png");
        background-size: cover;
        background-position: right bottom;
        background-repeat: no-repeat;
        min-height: 100vh;
        padding-top: 40px;
        box-sizing: border-box;
    }

    .logo-box {
        margin-bottom: 30px;
        img{
            display: block;
            height: 72px;
        }
    }

    .login-box {
        width: 560px;
        padding-bottom: 20px;
        border-radius: 15px;
        background: #fff;
        /*overflow: hidden;*/

        .input-box {
            width: 370px;
            margin: 20px auto;

            .input-title {
                font-size: 24px;
                text-align: center;
                line-height: 100px;
            }
        }

        .hint {
            text-align: center;
            color: #fa4860;
            font-size: 16px;
            margin: 30px auto;
            width: 370px;

            span {
                width: 100%;
                box-sizing: border-box;
                display: inline-block;
                border-radius: 5px;
                padding: 10px 20px;
                background-color: #f3f3f3;
            }
        }

        .tips {
            font-size: 12px;
            color: #666;

            span {
                cursor: pointer;
            }

            .to-register {
                color: #00BFCC;
            }
        }

        .button-box {
            display: flex;

            .submit-btn {
                flex: 1;
            }

            .inquiry-btn {
                width: 145px;
            }
        }
    }

    .login-title {
        position: relative;
        height: 50px;
        background-color: #25C6C7;
        border-radius: 8px 8px 0 0;

        .title {
            font-size: 18px;
            color: #fff;
        }

        .cycle-box {
            position: absolute;
            top: 0;
            left: 10px;
            height: 100%;

            span {
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                margin: 0 5px;
            }

            > span:nth-child(1) {
                background-color: #FF8493;
            }

            > span:nth-child(2) {
                background-color: #F8D44F;
            }

            > span:nth-child(3) {
                background-color: #7ED321;
            }
        }
    }

    .login-form {
        .verify-box {
            align-items: flex-end;
        }
    }

    .login-bottom-img {
        margin-top: -30px;
        width: 560px;
        img {
            width: 140px;
            display: block;
        }
    }

    @media (max-width: 768px ) {
        .login-bottom-img {
            width: 100%;
            display: none;
        }
    }
</style>